// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/active-flag.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/inactive-flag.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/info.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/images/edit.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/images/Artboard 4.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/images/delete.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/images/Artboard 3down.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/images/Artboard 3up.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Table css */

.table-bordered {
    border: none !important;
    width: 99.9% !important
}

.table-bordered td {
    border: none !important;
}

tbody tr {
    border-bottom: 5px solid #f0f0f0!important;
}

.table th {
    /* background-color: #e6e6e6; */
    background-repeat: no-repeat;
    /* background-image: -webkit-linear-gradient(#ffffff, #ffffff 25%, #e6e6e6);
  background-image: linear-gradient(#ffffff, #ffffff 25%, #e6e6e6); */
    color: #202020;
    font-size: 14px;
    line-height: normal;
    font-weight: normal;
    text-align: center;
    font-weight: bold;
}

.table>thead>tr>th {
    padding-bottom: 5px;
    padding-top: 5px;
    border: none !important;
    font-size: 0.81rem;
}

.table>tbody {
    background-color: #fff;
}

.table>tbody>tr>td {
    font-size: 0.81rem;
    text-align: center;
    color: #595d60;
}

/* Table css ends here */

#pageDropDown span span.caret {
    display: none;
}

.greenColor {
    color: green !important;
}

.orangeColor {
    color: orange !important;
}

.greyColor {
    color: grey !important;
}

.active-flag {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 18px;
    background-position: center;
    margin: 0 0.3rem;
    background-repeat: no-repeat;
}

.inactive-flag {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    height: 18px;
    background-position: center;
    margin: 0 0.3rem;
    background-repeat: no-repeat;
}

.info-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    height: 19px;
    width: 19px;
    background-position: center;
    margin: 0 0.3rem;
}

.edit-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    height: 18px;
    width: 18px;
    background-position: center;
    margin: 0 0.3rem;
}

.add-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    height: 25px;
    width: 26px;
    background-position: center;
    margin: 0 0.3rem;
    float: right;
}

.delete-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    height: 18px;
    width: 18px;
    background-position: center;
    margin: 0 0.3rem;
}

.kpiTableContainer .tab-content {
    border-bottom-right-radius: 1.25rem;
    border-bottom-left-radius: 1.25rem;
    border-top-right-radius: 1.25rem;
    background-color: #f0f0f0;
   /*  padding: 0.5rem; */
    /* height: 33rem; */
    width: 99%;
    margin-top: 2px;
   
}

.kpiTableContainer{
    padding-left: 30px !important;
}

.react-bootstrap-table {
    /* height: 28rem !important; */
    /* overflow-y: auto; */
    /* overflow-x: hidden; */
}

span.react-bootstrap-table-sort-order {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    width: 16px;
    height: 20px;
    float: left;
    background-position: center;
    position: absolute;
    background-size: 80px 60px;
}

span.react-bootstrap-table-sort-order.dropup {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    width: 16px;
    height: 20px;
    float: left;
    position: absolute;
    background-position: center;
    background-size: 80px 60px;
}

.caret {
    color: #f0f0f0 !important;
    position: absolute;
    margin: 0px !important;
    top: -400px !important;
}

.react-bootstrap-table th .order>.dropup>.caret {
    position: absolute;
}

/* Confirm Alert CSS  */

.react-confirm-alert-overlay {
    z-index: 1040;
    background: rgba(0, 0, 0, 0.5);
}

.react-confirm-alert-body {
    border-radius: 20px;
    padding: 0px;
    white-space: pre-wrap
}

.react-confirm-alert {
    /* border: 1px solid #e50000; */
    border-radius: 20px;
    background: #fff;
}

.react-confirm-alert-button-group>button {
    background: #e50000;
    border: 1px solid #e50000;
    border-radius: 16px;
}

.react-confirm-alert-body>h1 {
    background-color: #e50000;
    color: white;
    border-top-left-radius: 18px;
    border-top-right-radius: 18px;
    padding-left: 1rem;
    font-size: 1.0rem;
    padding: 0.5rem;
}

.react-confirm-alert-button-group {
    padding: 1rem;
    padding-bottom: 0.5rem;
    margin: 0px;
}

/* Table header stick  */

/* .tmeTable thead, .tmeTable tr, .tmeTable td, .tmeTable th { display: block; } */

.tmeTable tr:after {
    content: ' ';
    display: block;
    visibility: hidden;
    clear: both;
}

.tmeTable tbody {
    height: 70vh;
    overflow-y: scroll;
    display: block;
}

.tmeTable tbody tr {
    display: block;
}

.tmeTable table {
    border-spacing: 3px 7px;
    border-collapse: separate;
}

.tmeTable tbody>tr>td {
    width: 9rem;
    float: left;
}

.tmeTable thead>tr>th {
    width: 9rem;
    float: left;
}

.tmeTable thead>tr>th:first-child {
    width: 2rem !important;
    float: left;
}

.tmeTable tbody>tr>td:first-child {
    width: 2rem;
    float: left;
}

.ConfirmBox-toyota, .ConfirmBox-lexus {
    font-family: Arial, Helvetica, sans-serif;
    width: 400px;
    text-align: left;
    border-radius: 18px;
    color: #666;
}

.react-confirm-alert>.ConfirmBox-toyota {
    /* background-color: #e50000 !important; */
    border: 1px solid #e50000 !important;
}

.react-confirm-alert>.ConfirmBox-lexus {
    /* background-color: #252525 !important; */
    border: 1px solid #252525 !important;
}

.ConfirmBox-toyota .ConfirmBoxTitle {
    background-color: #e50000;
    color: #fff;
    border-top-left-radius: 18px;
    border-top-right-radius: 18px;
    font-size: 1rem;
    padding: .5rem;
}

.ConfirmBox-lexus .ConfirmBoxTitle {
    background-color: #252525;
    color: #fff;
    border-top-left-radius: 18px;
    border-top-right-radius: 18px;
    font-size: 1rem;
    padding: .5rem;
}

.ConfirmBox-toyota .ConfirmBoxTitle {
    background-color: #e50000;
    color: #fff;
    border-top-left-radius: 18px;
    border-top-right-radius: 18px;
    font-size: 1rem;
    padding: .5rem;
}

.ConfirmBoxBody {
    padding: 10px;
}

.ConfirmBoxFooter {
    display: flex;
    justify-content: flex-end;
    padding: 1rem;
    font-size: 14px;
}

.ConfirmBoxFooter .button {
    background-color: #e50000;
    border: none;
    color: white;
    padding: 1.25rem;
    padding-top: 1.25rem;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    margin: 4px 2px;
    cursor: pointer;
    border-radius: 1.25rem;
    padding-top: 0.590rem;
    height: 2.5rem;
}
/* .kpiTableContainer .tmeTable tbody {
    height: 478px;
}
.subQuestionTable {
    margin-top: 4.2rem !important;
}
.subQuestionTable Table tbody{
    height: 18vh !important;
    overflow-y: scroll;
}
.subQuestionTable Table{
    border-spacing: 3px 5px;
}
.mainQuestionSection {
    height: 12rem;
    overflow-y: scroll;
}
.leftNavCollapseBtn-toyota{
    height: 97%;
} */
.tmeTable tbody{
    height:80vh;
  }
`, "",{"version":3,"sources":["webpack://./src/components/table/index.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,+BAA+B;IAC/B,4BAA4B;IAC5B;qEACiE;IACjE,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA,wBAAwB;;AAExB;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yDAA4D;IAC5D,YAAY;IACZ,2BAA2B;IAC3B,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,yDAA8D;IAC9D,YAAY;IACZ,2BAA2B;IAC3B,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,yDAAqD;IACrD,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,yDAAqD;IACrD,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,yDAA2D;IAC3D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,yDAAuD;IACvD,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,kCAAkC;IAClC,gCAAgC;IAChC,yBAAyB;GAC1B,sBAAsB;IACrB,mBAAmB;IACnB,UAAU;IACV,eAAe;;AAEnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,yDAA+D;IAC/D,WAAW;IACX,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,yDAA6D;IAC7D,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA,uBAAuB;;AAEvB;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ;AACJ;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,4BAA4B;IAC5B,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA,wBAAwB;;AAExB,kFAAkF;;AAElF;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,yCAAyC;IACzC,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,0CAA0C;IAC1C,oCAAoC;AACxC;;AAEA;IACI,0CAA0C;IAC1C,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,4BAA4B;IAC5B,6BAA6B;IAC7B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,4BAA4B;IAC5B,6BAA6B;IAC7B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,4BAA4B;IAC5B,6BAA6B;IAC7B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,sBAAsB;IACtB,qBAAqB;IACrB,cAAc;AAClB;AACA;;;;;;;;;;;;;;;;;;;GAmBG;AACH;IACI,WAAW;EACb","sourcesContent":["/* Table css */\n\n.table-bordered {\n    border: none !important;\n    width: 99.9% !important\n}\n\n.table-bordered td {\n    border: none !important;\n}\n\ntbody tr {\n    border-bottom: 5px solid #f0f0f0!important;\n}\n\n.table th {\n    /* background-color: #e6e6e6; */\n    background-repeat: no-repeat;\n    /* background-image: -webkit-linear-gradient(#ffffff, #ffffff 25%, #e6e6e6);\n  background-image: linear-gradient(#ffffff, #ffffff 25%, #e6e6e6); */\n    color: #202020;\n    font-size: 14px;\n    line-height: normal;\n    font-weight: normal;\n    text-align: center;\n    font-weight: bold;\n}\n\n.table>thead>tr>th {\n    padding-bottom: 5px;\n    padding-top: 5px;\n    border: none !important;\n    font-size: 0.81rem;\n}\n\n.table>tbody {\n    background-color: #fff;\n}\n\n.table>tbody>tr>td {\n    font-size: 0.81rem;\n    text-align: center;\n    color: #595d60;\n}\n\n/* Table css ends here */\n\n#pageDropDown span span.caret {\n    display: none;\n}\n\n.greenColor {\n    color: green !important;\n}\n\n.orangeColor {\n    color: orange !important;\n}\n\n.greyColor {\n    color: grey !important;\n}\n\n.active-flag {\n    background-image: url(\"../../assets/images/active-flag.png\");\n    height: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n    background-repeat: no-repeat;\n}\n\n.inactive-flag {\n    background-image: url(\"../../assets/images/inactive-flag.png\");\n    height: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n    background-repeat: no-repeat;\n}\n\n.info-icon {\n    background-image: url(\"../../assets/images/info.png\");\n    height: 19px;\n    width: 19px;\n    background-position: center;\n    margin: 0 0.3rem;\n}\n\n.edit-icon {\n    background-image: url(\"../../assets/images/edit.png\");\n    height: 18px;\n    width: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n}\n\n.add-icon {\n    background-image: url(\"../../assets/images/Artboard 4.png\");\n    height: 25px;\n    width: 26px;\n    background-position: center;\n    margin: 0 0.3rem;\n    float: right;\n}\n\n.delete-icon {\n    background-image: url(\"../../assets/images/delete.png\");\n    height: 18px;\n    width: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n}\n\n.kpiTableContainer .tab-content {\n    border-bottom-right-radius: 1.25rem;\n    border-bottom-left-radius: 1.25rem;\n    border-top-right-radius: 1.25rem;\n    background-color: #f0f0f0;\n   /*  padding: 0.5rem; */\n    /* height: 33rem; */\n    width: 99%;\n    margin-top: 2px;\n   \n}\n\n.kpiTableContainer{\n    padding-left: 30px !important;\n}\n\n.react-bootstrap-table {\n    /* height: 28rem !important; */\n    /* overflow-y: auto; */\n    /* overflow-x: hidden; */\n}\n\nspan.react-bootstrap-table-sort-order {\n    background-image: url(\"../../assets/images/Artboard 3down.png\");\n    width: 16px;\n    height: 20px;\n    float: left;\n    background-position: center;\n    position: absolute;\n    background-size: 80px 60px;\n}\n\nspan.react-bootstrap-table-sort-order.dropup {\n    background-image: url(\"../../assets/images/Artboard 3up.png\");\n    width: 16px;\n    height: 20px;\n    float: left;\n    position: absolute;\n    background-position: center;\n    background-size: 80px 60px;\n}\n\n.caret {\n    color: #f0f0f0 !important;\n    position: absolute;\n    margin: 0px !important;\n    top: -400px !important;\n}\n\n.react-bootstrap-table th .order>.dropup>.caret {\n    position: absolute;\n}\n\n/* Confirm Alert CSS  */\n\n.react-confirm-alert-overlay {\n    z-index: 1040;\n    background: rgba(0, 0, 0, 0.5);\n}\n\n.react-confirm-alert-body {\n    border-radius: 20px;\n    padding: 0px;\n    white-space: pre-wrap\n}\n\n.react-confirm-alert {\n    /* border: 1px solid #e50000; */\n    border-radius: 20px;\n    background: #fff;\n}\n\n.react-confirm-alert-button-group>button {\n    background: #e50000;\n    border: 1px solid #e50000;\n    border-radius: 16px;\n}\n\n.react-confirm-alert-body>h1 {\n    background-color: #e50000;\n    color: white;\n    border-top-left-radius: 18px;\n    border-top-right-radius: 18px;\n    padding-left: 1rem;\n    font-size: 1.0rem;\n    padding: 0.5rem;\n}\n\n.react-confirm-alert-button-group {\n    padding: 1rem;\n    padding-bottom: 0.5rem;\n    margin: 0px;\n}\n\n/* Table header stick  */\n\n/* .tmeTable thead, .tmeTable tr, .tmeTable td, .tmeTable th { display: block; } */\n\n.tmeTable tr:after {\n    content: ' ';\n    display: block;\n    visibility: hidden;\n    clear: both;\n}\n\n.tmeTable tbody {\n    height: 70vh;\n    overflow-y: scroll;\n    display: block;\n}\n\n.tmeTable tbody tr {\n    display: block;\n}\n\n.tmeTable table {\n    border-spacing: 3px 7px;\n    border-collapse: separate;\n}\n\n.tmeTable tbody>tr>td {\n    width: 9rem;\n    float: left;\n}\n\n.tmeTable thead>tr>th {\n    width: 9rem;\n    float: left;\n}\n\n.tmeTable thead>tr>th:first-child {\n    width: 2rem !important;\n    float: left;\n}\n\n.tmeTable tbody>tr>td:first-child {\n    width: 2rem;\n    float: left;\n}\n\n.ConfirmBox-toyota, .ConfirmBox-lexus {\n    font-family: Arial, Helvetica, sans-serif;\n    width: 400px;\n    text-align: left;\n    border-radius: 18px;\n    color: #666;\n}\n\n.react-confirm-alert>.ConfirmBox-toyota {\n    /* background-color: #e50000 !important; */\n    border: 1px solid #e50000 !important;\n}\n\n.react-confirm-alert>.ConfirmBox-lexus {\n    /* background-color: #252525 !important; */\n    border: 1px solid #252525 !important;\n}\n\n.ConfirmBox-toyota .ConfirmBoxTitle {\n    background-color: #e50000;\n    color: #fff;\n    border-top-left-radius: 18px;\n    border-top-right-radius: 18px;\n    font-size: 1rem;\n    padding: .5rem;\n}\n\n.ConfirmBox-lexus .ConfirmBoxTitle {\n    background-color: #252525;\n    color: #fff;\n    border-top-left-radius: 18px;\n    border-top-right-radius: 18px;\n    font-size: 1rem;\n    padding: .5rem;\n}\n\n.ConfirmBox-toyota .ConfirmBoxTitle {\n    background-color: #e50000;\n    color: #fff;\n    border-top-left-radius: 18px;\n    border-top-right-radius: 18px;\n    font-size: 1rem;\n    padding: .5rem;\n}\n\n.ConfirmBoxBody {\n    padding: 10px;\n}\n\n.ConfirmBoxFooter {\n    display: flex;\n    justify-content: flex-end;\n    padding: 1rem;\n    font-size: 14px;\n}\n\n.ConfirmBoxFooter .button {\n    background-color: #e50000;\n    border: none;\n    color: white;\n    padding: 1.25rem;\n    padding-top: 1.25rem;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    margin: 4px 2px;\n    cursor: pointer;\n    border-radius: 1.25rem;\n    padding-top: 0.590rem;\n    height: 2.5rem;\n}\n/* .kpiTableContainer .tmeTable tbody {\n    height: 478px;\n}\n.subQuestionTable {\n    margin-top: 4.2rem !important;\n}\n.subQuestionTable Table tbody{\n    height: 18vh !important;\n    overflow-y: scroll;\n}\n.subQuestionTable Table{\n    border-spacing: 3px 5px;\n}\n.mainQuestionSection {\n    height: 12rem;\n    overflow-y: scroll;\n}\n.leftNavCollapseBtn-toyota{\n    height: 97%;\n} */\n.tmeTable tbody{\n    height:80vh;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
